






















import { Component, Prop, Vue } from 'vue-property-decorator';
import { mapGetters } from 'vuex';
import { User } from '@/models/User';
import { BAlert, BModal } from 'bootstrap-vue';

@Component({
    name: 'ModalUserRemove',
    components: {
        'b-alert': BAlert,
        'b-modal': BModal,
    },
    computed: mapGetters({
        account: 'account/account',
    }),
})
export default class ModalUserRemove extends Vue {
    error = '';
    updating = false;
    deleteError = '';
    account!: User;

    @Prop() private user!: User;

    async removeUser() {
        this.updating = true;

        try {
            const r = await this.$store.dispatch('users/delete', this.user);

            if (r.response) {
                if (r.response.status === 404) {
                    throw new Error(`User not found (${r.response.status})`);
                }

                if (r.response.status === 500) {
                    throw new Error(`An error occured (${r.response.status})`);
                }
            }

            this.$bvModal.hide(`modalUserRemove-${this.user.id}`);
        } catch (e) {
            this.error = e.toString();
        } finally {
            this.updating = false;
        }
    }
}
